import { SVGAttributes } from 'react';
import { ReactComponent as ActiveLocationSvg } from './active_location.svg';

export const ActiveLocationIcon = (styles: SVGAttributes<SVGElement>) => {
    return <ActiveLocationSvg {...styles} />;
};
